const currentYear = new Date().getFullYear();

const locale = {
    code: "hi",
    label: "हिन्दी",
    NAV_BAR: {
        home: "होम",
        homeId: "home",
        aboutus: "हमारे बारे में",
        aboutId: "aboutus",
        faq: "FAQ",
        faqId: "faq-section",
        contact: "संपर्क करें",
        contactId: "contact-section",
        button: "जल्दी पहुँच प्राप्त करें",
    },

    HERO: {
        heroHeading: "आपका मेनू, तुरंत उपलब्ध",
        heroParagraph:
            "एक QR कोड से अपना मेनू बनाएं, अपडेट करें और साझा करें — कोई झंझट नहीं, कोई पुनर्मुद्रण नहीं।",
        button: "जल्दी पहुँच प्राप्त करें",
        downloadText: "डाउनलोड करें",
        appStore: "App Store",
        getItOn: "GET IT ON",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "हमारी सेवाएँ",
        cards: [
            {
                title: "मेनू बनाएं और अपलोड करें",
                description:
                    "सिर्फ कुछ क्लिक में आसानी से अपना मेनू बनाएं और अपलोड करें! आइटम जोड़ें, कीमतें सेट करें, और बिना तकनीकी ज्ञान के विवरण अपडेट करें।",
            },
            {
                title: "मेनू अपडेट करें",
                description:
                    "कभी भी, कहीं भी अपने मेनू को वास्तविक समय में अपडेट करें! कीमतें बदलें, नए व्यंजन जोड़ें या उपलब्ध नहीं व्यंजन तुरंत संग्रहित करें।",
            },
            {
                title: "जनरेट और साझा करें",
                description:
                    "अपने मेनू के लिए तुरंत एक अनूठा QR कोड जनरेट करें! इसे तालिकाओं, पोस्टरों या ऑनलाइन साझा करें ताकि ग्राहक स्कैन करके अपने नवीनतम मेनू तक पहुंच सकें।",
            },
        ],
    },

    FEATURES: {
        heading: "हमारी शानदार विशेषताएँ खोजें",
        lists: [
            {
                title: "मेनू प्रबंधित करें",
                description:
                    "कभी भी अपना मेनू प्रबंधित करें! आसानी से आइटम जोड़ें, संपादित करें या हटाएं और अपने ग्राहकों के लिए अपनी पेशकश ताज़ा रखें।",
            },
            {
                title: "इनसाइट और रिपोर्ट",
                description:
                    "रियल-टाइम रिपोर्ट के साथ मूल्यवान अंतर्दृष्टि प्राप्त करें! अपने मेनू व्यूज़, QR कोड स्कैन और ग्राहक इंटरैक्शन को ट्रैक करें।",
            },
            {
                title: "QR कोड साझा करें",
                description:
                    "अपने मेनू को एक अनूठे QR कोड के साथ साझा करें! इसे तालिकाओं, पोस्टरों या ऑनलाइन प्रदर्शित करें ताकि ग्राहक तुरंत स्कैन करके अपने नवीनतम मेनू तक पहुंच सकें।",
            },
            {
                title: "ग्राहक समीक्षाएँ",
                description:
                    "वास्तविक समीक्षाओं और रेटिंग के साथ ग्राहक प्रतिक्रिया प्रदर्शित करें! विश्वास बनाएं, अपने मेनू में सुधार करें, और भोजन अनुभव को बेहतर बनाएं।",
            },
            {
                title: "ऑफ़र और छूट",
                description:
                    "विशेष ऑफ़र और छूट के साथ बिक्री बढ़ाएँ! सीमित समय के प्रचार और विशेष छूट हाइलाइट करें।",
            },
        ],
    },

    ABOUT: {
        heading: "My QR Menu के बारे में",
        headingPara: "रीयल-टाइम अपडेट के साथ अपने रेस्टोरेंट मेनू प्रबंधन को सरल बनाएं।",
        highlightHeading: "आपको जो चाहिए, वह तेज़ और आसान है",
        highlightPara: "आपकी सभी मेनू सुविधाएँ — सिर्फ एक टच में।",
        cards: {
            left: {
                heading: ["आवश्यक सामग्री आसानी से जोड़ें", "अपने QR मेनू में"],
                alt: "सामग्री जोड़ें",
            },
            right: {
                heading: ["अपने मेनू", "डैशबोर्ड तक आसानी से पहुंचें"],
                alt: "मेनू डैशबोर्ड",
            },
        },
    },

    FAQ: {
        heading: "आपके पास सवाल हैं। हमारे पास जवाब हैं।",
        subheading: "उत्पाद के बारे में वह सब कुछ जो आपको जानना चाहिए।",
        items: [
            {
                question: "My QRMenu क्या है?",
                answer:
                    "My QRMenu एक डिजिटल मेनू प्लेटफ़ॉर्म है जो रेस्टोरेंट्स को QR कोड का उपयोग करके अपने मेनू को तुरंत बनाने, अपडेट करने और साझा करने की सुविधा देता है।",
            },
            {
                question: "क्या मैं अपने मेनू को बनाने के बाद अपडेट कर सकता हूँ?",
                answer:
                    "हाँ, आप कभी भी अपने मेनू को अपडेट कर सकते हैं और यह तुरंत दिखाई देगा जब ग्राहक आपका QR कोड स्कैन करेंगे।",
            },
            {
                question: "My QRMenu कैसे काम करता है?",
                answer:
                    "आप एक मेनू बनाते हैं, एक QR कोड जनरेट करते हैं, और ग्राहक स्कैन करके आपके नवीनतम मेनू को देखते हैं।",
            },
            {
                question: "मैं अपना QR कोड कैसे साझा करूं?",
                answer:
                    "आप QR कोड को डिजिटल रूप से साझा कर सकते हैं या इसे अपने रेस्टोरेंट में प्रदर्शित करने के लिए प्रिंट कर सकते हैं।",
            },
            {
                question: "क्या My QRMenu मोबाइल-फ्रेंडली है?",
                answer:
                    "हाँ, My QRMenu सभी डिवाइसेज़ के लिए अनुकूल है, जिसमें मोबाइल फोन और टैबलेट शामिल हैं।",
            },
            {
                question: "क्या मैं ग्राहक समीक्षाएँ एकत्र कर सकता हूँ?",
                answer:
                    "हाँ, आप ग्राहक समीक्षाएँ सक्षम कर सकते हैं और अपनी पेशकश को बेहतर बनाने के लिए प्रतिक्रिया का उपयोग कर सकते हैं।",
            },
        ],
    },

    CONTACT: {
        heading: "संपर्क करें",
        subheading: "हमारी मैत्री टीम आपकी सहायता के लिए तैयार है।",
        firstName: "पहला नाम",
        lastName: "अंतिम नाम",
        email: "ईमेल",
        message: "संदेश",
        firstNamePlaceholder: "पहला नाम",
        lastNamePlaceholder: "अंतिम नाम",
        emailPlaceholder: "आप@कंपनी.com",
        messagePlaceholder: "अपना संदेश लिखें...",
        privacyConsent: "आप हमारी सहमत हैं",
        privacyPolicy: "गोपनीयता नीति",
        submitButton: "संदेश भेजें",
        toast: {
            requiredConsent: "आपको गोपनीयता नीति से सहमत होना आवश्यक है।",
            submitting: "संदेश सबमिट किया जा रहा है...",
            success: "संदेश सफलतापूर्वक भेजा गया!",
            fail: "संदेश भेजने में विफल। कृपया पुनः प्रयास करें।",
            error: "एक त्रुटि हुई। कृपया अपना कनेक्शन जांचें।",
        },
    },

    HELP_PAGE: {
        title: "सहायता केंद्र",
        description: "यदि आपके पास कोई प्रश्न है या सहायता की आवश्यकता है, तो कृपया हमसे संपर्क करें: ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "या नीचे हमारी अक्सर पूछे जाने वाले प्रश्न देखें, आपको संभवतः वही मिल जाएगा जो आप ढूंढ रहे हैं।",
    },

    FOOTER: {
        footerHeading: "सीमलेस डिजिटल मेनू, सरल!",
        footerButton: "वेटलिस्ट में शामिल हों",
        footerConnect: "हमसे जुड़ें",
        footerTerms: "शर्तें और समझौते",
        footerHelp: "सहायता केंद्र",
        footerPrivacy: "गोपनीयता नीति",
        footerCopyright: `©${currentYear} सर्वाधिकार सुरक्षित।`,
    },

    PRIVACY_POLICY: {
        title: "गोपनीयता नीति",
        lastUpdated: "अंतिम अपडेट: 22 मई, 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                यह गोपनीयता नीति सेवा का उपयोग करने पर आपकी जानकारी के संग्रह, उपयोग और प्रकटीकरण पर हमारी नीतियों और प्रक्रियाओं का वर्णन करती है।
                </p>
                <p class="mb-6 leading-relaxed">
                हम सेवा प्रदान करने और सुधारने के लिए आपके व्यक्तिगत डेटा का उपयोग करते हैं। सेवा का उपयोग करके, आप इस गोपनीयता नीति के अनुसार जानकारी के संग्रह और उपयोग के लिए सहमत होते हैं।
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">व्याख्या और परिभाषाएं</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">व्याख्या</h3>
                <p class="mb-6 leading-relaxed">
                    जिन शब्दों का पहला अक्षर बड़ा है, उनके अर्थ निम्नलिखित स्थितियों के तहत परिभाषित हैं।
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">परिभाषाएं</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>खाता</strong> का अर्थ है हमारी सेवा तक पहुँचने के लिए आपके लिए बनाया गया एक अनूठा खाता।</li>
                    <li><strong>कंपनी</strong> का तात्पर्य <strong>My QR Menu,</strong> लंदन, यूनाइटेड किंगडम से है।</li>
                    <li><strong>व्यक्तिगत डेटा</strong> वह जानकारी है जो एक पहचाने गए या पहचाने जाने योग्य व्यक्ति से संबंधित है।</li>
                    <li><strong>आप</strong> का अर्थ सेवा का उपयोग करने वाले व्यक्ति से है।</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">संपर्क करें</h2>
                <p>
                यदि आपके पास इस गोपनीयता नीति के बारे में कोई प्रश्न हैं, तो आप हमसे संपर्क कर सकते हैं:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>ईमेल द्वारा: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "नियम और शर्तें",
        lastUpdated: "अंतिम अपडेट: 22 मई, 2025",
        content: `
            <p class="leading-relaxed mb-6">
            कृपया हमारे ऐप या वेबसाइट का उपयोग करने से पहले इन नियमों और शर्तों को ध्यान से पढ़ें।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. व्याख्या और परिभाषाएं</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">व्याख्या</h3>
            <p class="leading-relaxed mb-4">
            जिन शब्दों का पहला अक्षर बड़ा है, उनके अर्थ निम्नलिखित स्थितियों के तहत परिभाषित हैं।
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">परिभाषाएं</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>एप्लिकेशन</strong> का अर्थ है My QR Menu द्वारा प्रदान किया गया सॉफ़्टवेयर।</li>
            <li><strong>कंपनी</strong> का तात्पर्य My QR Menu, लंदन, यूके से है।</li>
            <li><strong>सेवा</strong> एप्लिकेशन और वेबसाइट को संदर्भित करती है।</li>
            <li><strong>आप</strong> का अर्थ सेवा का उपयोग करने वाले व्यक्ति या व्यवसाय से है।</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. पावती</h2>
            <p class="leading-relaxed mb-6">
            सेवा का उपयोग करके, आप इन शर्तों से बंधे होने के लिए सहमत हैं। यदि आप किसी भी हिस्से से असहमत हैं, तो आप सेवा का उपयोग नहीं कर सकते।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. अन्य वेबसाइटों के लिंक</h2>
            <p class="leading-relaxed mb-6">
            हमारी सेवा में तीसरे पक्ष की वेबसाइटों के लिंक हो सकते हैं। हम उनकी सामग्री या प्रथाओं के लिए कोई जिम्मेदारी नहीं लेते हैं।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. समाप्ति</h2>
            <p class="leading-relaxed mb-6">
            हम किसी भी कारण से बिना पूर्व सूचना के आपकी सेवा तक पहुँच को तुरंत समाप्त या निलंबित करने का अधिकार सुरक्षित रखते हैं।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. दायित्व की सीमा</h2>
            <p class="leading-relaxed mb-6">
            कानून द्वारा अनुमत अधिकतम सीमा तक, सेवा के उपयोग से उत्पन्न होने वाले किसी भी नुकसान के लिए कंपनी जिम्मेदार नहीं होगी।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. "जैसा है" और "जैसा उपलब्ध है" अस्वीकरण</h2>
            <p class="leading-relaxed mb-6">
            सेवा आपको "जैसा है" और "जैसा उपलब्ध है" आधार पर प्रदान की जाती है। हम गारंटी नहीं देते हैं कि यह त्रुटि मुक्त या निर्बाध होगा।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. शासी कानून</h2>
            <p class="leading-relaxed mb-6">
            ये शर्तें यूनाइटेड किंगडम के कानूनों द्वारा शासित होंगी।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. विवाद समाधान</h2>
            <p class="leading-relaxed mb-6">
            यदि आपका हमारे साथ कोई विवाद है, तो आप कानूनी कार्रवाई करने से पहले इसे अनौपचारिक रूप से हल करने का प्रयास करने के लिए सहमत हैं।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. यूरोपीय संघ (EU) उपयोगकर्ताओं के लिए</h2>
            <p class="leading-relaxed mb-6">
            यदि आप यूरोपीय संघ के उपभोक्ता हैं, तो आप अपने निवास देश के कानून के अनिवार्य प्रावधानों की सुरक्षा के हकदार हैं।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. संयुक्त राज्य अमेरिका कानूनी अनुपालन</h2>
            <p class="leading-relaxed mb-6">
            आप प्रतिनिधित्व करते हैं और गारंटी देते हैं कि आप अमेरिकी सरकार के प्रतिबंधों के अधीन किसी देश में स्थित नहीं हैं।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. विच्छेदनीयता और अधित्याग</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">विच्छेदनीयता</h3>
            <p class="leading-relaxed mb-4">
            यदि इन शर्तों का कोई प्रावधान अप्रवर्तनीय पाया जाता है, तो शेष प्रावधान प्रभावी रहेंगे।
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">अधित्याग</h3>
            <p class="leading-relaxed mb-6">
            किसी प्रावधान को लागू करने में विफलता उस अधिकार का अधित्याग नहीं माना जाएगा।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. अनुवाद व्याख्या</h2>
            <p class="leading-relaxed mb-6">
            हो सकता है कि इन शर्तों का अनुवाद किया गया हो। विवाद की स्थिति में अंग्रेजी संस्करण मान्य होगा।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. इन शर्तों में बदलाव</h2>
            <p class="leading-relaxed mb-6">
            हम किसी भी समय इन शर्तों को अपडेट कर सकते हैं। हम अपनी वेबसाइट पर एक नोटिस पोस्ट करके आपको सूचित करेंगे।
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. संपर्क करें</h2>
            <p class="leading-relaxed mb-2">यदि आपके पास इन शर्तों के बारे में प्रश्न हैं, तो आप हमसे संपर्क कर सकते हैं:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>ईमेल द्वारा: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
